import { useNavigate, useSearch } from "@tanstack/react-router";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@portal/ui";
import { SyncCard } from "../candidates/SyncCard";
import { AdminAnnouncementsPage } from "./AdminAnnouncementsPage";
import { AdminCompanyLinksPage } from "./AdminCompanyLinksPage";
import { AdminSystemAdminsPage } from "./AdminSystemAdminsPage";
import { AdminUsersPage } from "./AdminUsersPage";

export const ADMIN_TABS = ["links", "announcements", "users", "sync", "admins"] as const;
type AdminTab = (typeof ADMIN_TABS)[number];

const TABS: { value: AdminTab; label: string }[] = [
  { value: "links", label: "ブックマーク" },
  { value: "announcements", label: "お知らせ" },
  // ユーザーマスタ(名前だけ。2026-10-15)
  { value: "users", label: "ユーザー" },
  { value: "sync", label: "同期" },
  { value: "admins", label: "管理者" },
];

/**
 * 管理画面(SYSTEM_ADMIN)。ナビには「管理」だけを置き、この 1 ページのタブで切り替える
 * (ユーザー要望 2026-09-07)。タブは URL の ?tab= に持たせ、再読み込みや共有で保持する。
 */
export function AdminPage() {
  const { tab } = useSearch({ from: "/app/admin" });
  const navigate = useNavigate();
  const current: AdminTab = tab ?? "links";
  return (
    <Tabs
      value={current}
      onValueChange={(v) => void navigate({ to: "/admin", search: { tab: v as AdminTab } })}
      className="gap-4"
    >
      <TabsList>
        {TABS.map((t) => (
          <TabsTrigger key={t.value} value={t.value}>
            {t.label}
          </TabsTrigger>
        ))}
      </TabsList>
      {/* タブの中身は表示中のものだけ描画し、それぞれ独立して取得する */}
      <TabsContent value="links">{current === "links" && <AdminCompanyLinksPage />}</TabsContent>
      <TabsContent value="announcements">
        {current === "announcements" && <AdminAnnouncementsPage />}
      </TabsContent>
      <TabsContent value="users">{current === "users" && <AdminUsersPage />}</TabsContent>
      <TabsContent value="sync">{current === "sync" && <SyncCard />}</TabsContent>
      <TabsContent value="admins">{current === "admins" && <AdminSystemAdminsPage />}</TabsContent>
    </Tabs>
  );
}
